import React from "react";
import * as Yup from 'yup';
import { ImpiantoDto, ImpiantoData, IAggiornaDateControlloData, ClienteDto, ApparecchioCategory } from "../../generated"
import { SmartCaldaiaSelector } from "../../caldaie/components/SmartCaldaiaSelector";
import { TipoCombustibileSelector } from "../../tipiCombustilbile/components/tipoCombustibileSelector";
import { TipoUsoCaldaiaSelector } from "../../tipiUsoCaldaia/components/tipoUsoCaldaiaSelector";
import { TipoLocaleSelector } from "../../tipiLocale/components/tipoLocaleSelector";
import { SmartBruciatoreSelector } from "../../bruciatori/components/SmartBruciatoreSelector";
import { FrazioneSelector } from "../../comuni/components/FrazioneSelector";
import { ComuniAutocomplete } from "../../comuni/components/comuniAutocomplete";
import { Forms, Divider } from "../../common/components/CmForms";
import { AccordionItem } from "../../common/accordion";
import { BolliniVerdiAccordion } from "../../bolliniVerdi/components/BolliniVerdiList";
import OpenModalButton from "../../common/components/openModalButton";
import { AggiornaDateControlloForm } from "./aggiornaDateControlloForm";
import ImpiantiHelper from "../ImpiantiHelper";
import { ContrattiAccordion } from "../../contratti/components/ContrattoAccordion";
import { CheckBox } from "../../common/components/checkBox2";
import { CustomerData } from "../../customers/components/CustomerData";
import CaldaiaData from "../../caldaie/components/caldaiaData";
import { FormTextInput } from "../../common/components/textInput";
import { ComuneData } from "../../comuni/components/ComuneData";
import { TipoCaldaiaSelector } from "../../tipiCaldaie/components/tipoCaldaiaSelector";
import { TipoTiraggioSelector } from "../../tipiTiraggio/components/tipoTiraggioSelector";
import { TechnicianSelector } from "../../technicians/components/TechnicianSelector";
import customersStore from "../../customers/customersStore";
import { withApparecchioCateogories } from "../withApparecchioCategories";
import { Dictionary } from "../../common/AbstractStores";
const { Form, FormText, FormInteger, FormDate, ActionBar, FormTextArea, isEqual } = Forms<ImpiantoFormData>()

export class ImpiantoFormData extends ImpiantoDto {
    createInterventi?: boolean;
}

interface Props {
    impianto: ImpiantoFormData;
    onSubmit: (impianto: ImpiantoDto) => void;
    onCancel: () => void;
    isNew: boolean;
    cliente: ClienteDto;
    apparecchioCategories: Dictionary<ApparecchioCategory>
}

export const ToImpiantoData = (impianto: ImpiantoDto) => ImpiantoData.fromJS({
    ...impianto,
    idCaldaia: impianto.idCaldaia,
    codFisComune: impianto.codFisComune,
    codFrazione: impianto.codFrazione,
    idBruciatore: impianto.idBruciatore,
    idCliente: impianto.idCliente,
});


const isImpiantoEqual = (i1: ImpiantoDto, i2: ImpiantoDto) => isEqual(ToImpiantoData(i1), ToImpiantoData(i2));

class ImpiantoForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<ImpiantoDto>>({
        dataUltimoControlloAnn: Yup
            .date()
            .min(new Date(1900, 1, 1), "Ultimo controllo non valido")
            .required("Campo obbligatorio"),
        dataUltimoControlloComb: Yup
            .date()
            .min(new Date(1900, 1, 1), "Ultimo controllo non valido")
            .required("Campo obbligatorio"),
        idCaldaia: Yup
            .number()
            .test("caldaia-required", "Campo obbligatorio", value => value != null && value > 0),
        tiraggio: Yup
            .string()
            .required("Campo obbligatorio"),
        tipoInstallazione: Yup
            .string()
            .required("Campo obbligatorio"),

    })

    private changeCheckDate = async (data: IAggiornaDateControlloData) => {
        const { impianto } = this.props;
        this.aggiornaDateControlloModal.current?.close();
        await ImpiantiHelper.evadiScadenze([impianto], data, this.props.apparecchioCategories);
    }

    private aggiornaDateControlloModal = React.createRef<OpenModalButton>();
    render() {
        const { impianto, isNew, cliente } = this.props;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={impianto}
                validationSchema={ImpiantoForm.validationSchema}
                isEqual={isImpiantoEqual}
            >
                {
                    ({ values, set, errors }) => {
                        const bruciatoreExist = values.idBruciatore != null && values.idBruciatore > 0;
                        const title = values.idCaldaia > 0
                            ? <span><CaldaiaData id={values.idCaldaia} template={x => x.marcaCaldaia ?? ""} /> di <CustomerData id={values.idCliente} template={x => x.cognomeProprietario ?? ""} /></span>
                            : "Nuovo impianto";
                        return <>
                            <div className="card">
                                <div className="card-header bg-theme ">
                                    <h3 className="text-white text-uppercase mb-0">
                                        {title}
                                    </h3>
                                </div>
                                <div className="card-body pb-4">
                                    <Divider caption="Dati apparecchio" />
                                    {/* <ImpiantoTermicoCategorySelector
                                        label="Tipo Apparecchio"
                                        value={values.type}
                                        onChange={type => set("type", type?.id ?? ApparecchioCategoryType.Caldaia)}
                                    /> */}
                                    <div className="row align-items-center">
                                        <div className="col-12 col-md-6">
                                            <SmartCaldaiaSelector
                                                error={errors.idCaldaia}
                                                onChange={value => set("idCaldaia", value?.idCaldaia ?? 0)}
                                                value={values.idCaldaia}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <FormDate
                                                        label="Data Installazione"
                                                        name="dataInstallazione"
                                                    />
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <FormDate
                                                        label="Data primo avvio"
                                                        name="dataPrimoAvvio"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormInteger
                                                        name="annoFabbricazione"
                                                        label="Anno fabbricazione"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="matricola"
                                                        label="Matricola"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="codiceImpiantoCatasto"
                                                        label="Cod.Targa"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="pdr"
                                                        label="Pdr"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="pod"
                                                        label="Pod"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Divider caption="Dati installazione" />
                                    <div className="row">
                                        <div className="col-12 col-sm-6">
                                            <TipoCaldaiaSelector
                                                value={values.tipoInstallazione ?? null}
                                                onChange={value => set("tipoInstallazione", value ?? undefined)}
                                                label="Tipo Installazione"
                                                error={errors.tipoInstallazione}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <TipoTiraggioSelector
                                                onChange={value => set("tiraggio", value ?? undefined)}
                                                value={values.tiraggio ?? null}
                                                label="Tiraggio"
                                                error={errors.tiraggio}
                                            />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <TipoCombustibileSelector
                                                value={values.combustibile ?? null}
                                                onChange={value => value && set("combustibile", value)}
                                                label="Combustibile"
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <TipoUsoCaldaiaSelector
                                                onChange={value => value && set("usoCaldaia", value)}
                                                value={values.usoCaldaia ?? null}
                                                label="Uso"
                                            />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-3">
                                            <TipoLocaleSelector
                                                onChange={value => value && set("localeInstallazione", value)}
                                                value={values.localeInstallazione ?? null}
                                                label="Locale Inst."
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormText
                                                name="volumetriaRiscaldata"
                                                label="Volumetria Riscaldata"
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <TechnicianSelector
                                                label="Installatore"
                                                onChange={technician => set("technicianId", technician?.id)}
                                                value={values.technicianId || null}
                                                error={errors.technicianId}
                                            />
                                        </div>
                                    </div>
                                    <AccordionItem
                                        open={bruciatoreExist}
                                        heading={isOpen =>
                                            <div>
                                                <Divider
                                                    caption={<span>
                                                        {bruciatoreExist ? "Bruciatore abbinato" : "Aggiungi bruciatore"}
                                                        {<i className={`${isOpen ? "fas fa-chevron-up" : "fas fa-chevron-down"} ms-2`} />}
                                                    </span>}
                                                    color={bruciatoreExist ? "theme" : "warning"}
                                                    additionalItems={isOpen && bruciatoreExist && <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => set("idBruciatore", undefined)}>
                                                        <i className="fas fa-trash" />
                                                    </button> || undefined}
                                                />
                                            </div>
                                        }>
                                        <div className="row">
                                            <div className="col-12 col-md-8">
                                                <SmartBruciatoreSelector
                                                    value={values.idBruciatore && values.idBruciatore > 0 ? values.idBruciatore : null}
                                                    onChange={bruciatore => set("idBruciatore", bruciatore?.idBruciatore)}
                                                    error={errors.idBruciatore}
                                                />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <FormInteger
                                                    name={"annoFabbricazioneBruciatore"}
                                                    label="Anno fabbric."
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <FormText
                                                    name={"matricolaBruciatore"}
                                                    label="Matricola Bruciatore"
                                                />
                                            </div>
                                            <div className="col-12 col-md-6">

                                            </div>
                                        </div>
                                    </AccordionItem>
                                    <Divider caption="Locazione Impianto" />
                                    <CheckBox
                                        checked={!values.inheritsAddress}
                                        label="Indirizzo diverso da quello del cliente"
                                        onChange={checked => set("inheritsAddress", !checked)}
                                    />
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <ComuniAutocomplete
                                                onChange={async comune => {
                                                    await set("codFisComune", comune?.codFisComune ?? undefined);
                                                    comune?.cap && await set("cap", comune?.cap ?? undefined);
                                                }}
                                                value={values.inheritsAddress ? cliente.comune?.codFisComune : values.codFisComune}
                                                label="Comune"
                                                error={errors.codFisComune}
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                        <div className="col-12 col-md-2">
                                            <ComuneData
                                                codFisComune={values.inheritsAddress ? (cliente.comune?.codFisComune ?? "") : (values.codFisComune ?? "")}
                                                selector={comune => <FormTextInput<ImpiantoData>
                                                    label="Cap"
                                                    name="cap"
                                                    value={values.inheritsAddress ? (cliente.cap ?? cliente.comune?.cap) : (values.cap ?? comune?.cap)}
                                                    onChange={e => set("cap", e.target.value)}
                                                    readOnly={values.inheritsAddress}
                                                />
                                                }
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <FormTextInput
                                                value={values.inheritsAddress ? cliente.indirizzo : values.indirizzo}
                                                onChange={e => set("indirizzo", e.target.value)}
                                                label="Indirizzo"
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            {(values.inheritsAddress ? cliente.comune?.codFisComune : values.codFisComune) && <FrazioneSelector
                                                codFisComune={values.inheritsAddress ? (cliente.comune?.codFisComune ?? "") : (values.codFisComune ?? "")}
                                                onChange={frazione => set("codFrazione", frazione?.codFrazione ?? undefined)}
                                                value={values.inheritsAddress ? (cliente.frazione?.codFrazione ?? null) : (values.codFrazione ?? null)}
                                                label="Frazione"
                                                error={errors.codFrazione}
                                                readonly={values.inheritsAddress}
                                            />}
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormTextInput
                                                label="Piano"
                                                onChange={piano => set("piano", piano.target.value)}
                                                value={values.inheritsAddress ? cliente.piano : values.piano}
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                    </div>
                                    <Divider caption="Scadenze" />
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <FormDate
                                                        name={"dataUltimoControlloAnn"}
                                                        label="Ultimo controllo annuale"
                                                        readOnly={!isNew}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormDate
                                                        name="dataUltimoControlloComb"
                                                        label="Ultimo controllo combust."
                                                        readOnly={!isNew}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    {!isNew && <OpenModalButton
                                                        ref={this.aggiornaDateControlloModal}
                                                        title="Aggiorna date controllo"
                                                        className="btn btn-outline-secondary w-100"
                                                        modalContent={
                                                            <AggiornaDateControlloForm
                                                                impiantiIds={[impianto.idImpianto]}
                                                                onSubmit={async data => {
                                                                    await this.changeCheckDate(data);
                                                                    if (data.controlloAnnualeChecked && data.dataUltimoControlloAnnuale)
                                                                        await set("dataUltimoControlloAnn", data.dataUltimoControlloAnnuale);
                                                                    if (data.controlloCombustioneChecked && data.dataUltimoControlloCombustione)
                                                                        await set("dataUltimoControlloComb", data.dataUltimoControlloCombustione);
                                                                }}
                                                            />
                                                        }>
                                                        <i className="fas fa-tasks me-2" /> Aggiorna date controllo
                                                    </OpenModalButton>
                                                        || <>
                                                            <CheckBox
                                                                label="Crea automaticamente lo storico interventi con le date di ultimo controllo"
                                                                onChange={checked =>
                                                                    set("createInterventi", checked)
                                                                }
                                                                checked={values.createInterventi == null || values.createInterventi == true}
                                                            />
                                                        </>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormTextArea
                                                name="noteImpianto"
                                                label="Nota Impianto"
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                    <BolliniVerdiAccordion impianto={impianto} isNew={isNew} />
                                    <ContrattiAccordion idImpianto={impianto.idImpianto} />
                                    <ActionBar onCancel={this.props.onCancel} />
                                </div>
                            </div>
                        </>
                    }
                }
            </Form >
        );
    }
}


const attached = (props: Omit<Props, "cliente">) => {
    const cliente = customersStore.use(props.impianto.idCliente);
    if (cliente == null)
        return null;
    return <ImpiantoForm {...props} cliente={cliente} />
}

export default withApparecchioCateogories(attached)(x => x.allByKey(), "apparecchioCategories")